import React from 'react';
import './index.css';
import Home from './routes/Home';
import About from './routes/About';
import Projects from './routes/Projects';
import Contact from './routes/Contact';
import { Routes, Route } from 'react-router-dom';

function App() {
  return (
   <>
   
      <Routes>
        <Route element={<Home/>} path="/" />
        <Route element={<About/>} path="/About"/>
        <Route element={<Projects/>} path="Projects"/>
        <Route element={<Contact/>} path="Contact"/>
      </Routes>
   
   </>
  );
}

export default App;
